<template>
    <section class="container margin-both-xl">
        <div class="inner">
            <div class="content mdoule-custom-desc" v-if="data.title">
                <h2 class="titler jost jost--35  text-center font--700">{{data.title}}</h2>
            </div>
            <div class="content form-wrap" ref="content" v-once>
            </div>
        </div>
    </section>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'form-picker',
    props : ['data'],
    mounted(){
        const content = this.$refs.content;
        const formId = this.data.select_form;
        if(formId){
            this.loadGravityForm2(formId, content)
        }
    },
    methods:{
        ...mapActions([
           // 'loadGravityForm'
        ]),
        loadGravityForm2(formId, content){
            const apiUrl  = window.WPVUE.home.replace(/\/$/, "") +'/'+window.WPVUE.ajaxurl
			return window.axios.get(apiUrl, {
                params: {
                    action : 'gf_button_get_form',
                    form_id : formId
                }}).then(res => {

   
                    if(content) {
                        window.jQuery(content).html(res.data)
                        if ( typeof window['gformInitDatepicker'] !== 'undefined' ) {
                            window.gformInitDatepicker()
                        }
                        if ( typeof window['tinyMCE'] !== 'undefined' && jQuery('textarea.wp-editor-area').length ) {
                            tinyMCE.init({
                                mode : "specific_textareas",
                                menu: {},
                                editor_selector :"wp-editor-area"
                            });
                        }

                    }
                    return res;
                })
        },
    }
}
</script>

<style lang="scss">
.module-form_picker{
    .inner{
        margin: 0 auto;
        max-width: 800px;
    }
    .titler{
        margin-top: 0;
    }
    
}
</style>